<template>
    <div class="preferences-listitem">
        <div class="row">
            <div class="col-6 d-none d-lg-block handle carousel-wrap">
                <house-thumb-carousel :house="house"></house-thumb-carousel>
            </div>
            <div class="col-12 col-lg-6">
                <house-tile :house="house"></house-tile>
            </div>
        </div>

        <div :class="{ visible: deleteVisible }" class="delete-preference">
            <div class="btn-wrapper">
                <button @click="deleteVisible" class="btn btn-grey">Behouden</button>
                <button class="btn btn-red">Verwijderen</button>
            </div>
        </div>
    </div>
</template>

<script>
    import HouseTile from '../components/HouseTile.vue'
    import HouseThumbCarousel from '../components/HouseThumbCarousel.vue'

    export default {
        props: ['house'],
        components: {
            HouseTile,
            HouseThumbCarousel
        },
        data() {
            return {
                deleteVisible: false
            }
        },
        methods: {
            dislike:function () {
                this.deleteVisible = !this.deleteVisible
            }
        }
    }
</script>
